import React from 'react'
import './App.scss'
import { AudioProvider } from './Provider/AudioProvider'
import { AuthProvider } from './Provider/AuthProvider'
import { CameraProvider } from './Provider/CameraProvider'
import { LoadingProvider } from './Provider/LoadingProvider'
import AppRouter from './pages/router'
function App({ isCheckIn }: { isCheckIn: boolean }) {
  return (
    <LoadingProvider>
      <AudioProvider>
        <AuthProvider>
          <CameraProvider>
            <AppRouter isCheckIn={isCheckIn} />
          </CameraProvider>
        </AuthProvider>
      </AudioProvider>
    </LoadingProvider>
  )

}

export default App
